
import React from 'react';
import { Eye } from 'lucide-react';
import { cn } from '@/lib/utils';
import ActionButton from './ActionButton';

interface ViewDetailsButtonProps {
  onClick?: () => void;
  className?: string;
}

const ViewDetailsButton = ({ onClick, className }: ViewDetailsButtonProps) => {
  return (
    <ActionButton 
      variant="blue"
      icon={<Eye size={16} />}
      onClick={onClick}
      className={cn(
        "absolute top-4 right-4",
        className
      )}
    >
      View Details
    </ActionButton>
  );
};

export default ViewDetailsButton;
